import { toast } from '@/stores/pure/ToastStore';
import { clipboardCopy } from '@/utils/util';

export const copyScrapingJobLink = (workspaceId: string, jobId: string) => {
  const link = `${window.location.origin}/workspace/${workspaceId}/settings/integration/scraping/${jobId}`;
  clipboardCopy(link);
  toast('Link copied to clipboard', 'success');
};
